<template>
    <div>
        <div class="section_filter" id="job-filter">
            <form @submit.prevent="applyFilters">
                <fieldset>
                    <div class="field dropdown" v-if="locations.length">
                        <label for="jae-location">{{ labels.location }}</label>
                        <div class="middleColumn">
                            <select id="jae-location" class="dropdown" v-model="filters.location" @change="applyFilters">
                                <option value="">{{ labels.all }}</option>
                                <option v-for="loc in locations" :key="loc.id" :value="loc.id">{{ loc.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="field dropdown" v-if="careers.length">
                        <label for="jae-career">{{ labels.career }}</label>
                        <div class="middleColumn">
                            <select id="jae-career" class="dropdown" v-model="filters.career" @change="applyFilters">
                                <option value="">{{ labels.all }}</option>
                                <option v-for="career in careers" :key="career.id" :value="career.id">{{ career.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="field text">
                        <label for="jae-search">{{ labels.search }}</label>
                        <div class="middleColumn">
                            <input id="jae-search" type="text" v-model="filters.search" :placeholder="labels.searchPlaceholder">
                        </div>
                    </div>
                </fieldset>
                <div class="btn-toolbar">
                    <input type="submit" :value="labels.findJobs" class="action btn action-major">
                    <input v-if="hasActiveFilters" type="button" :value="labels.resetFilter" @click="resetFilters" class="action btn filter_reset">
                </div>
            </form>
        </div>
        <div class="section_table">
            <p class="entry-count">{{ entriesFoundText }}</p>
            <table class="job-advertisement-table">
                <thead>
                    <tr>
                        <th>{{ labels.jobTitle }}</th>
                        <th>{{ labels.jobLocation }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="job in displayedJobs" :key="job.id">
                        <td><a :href="detailBaseUrl + 'view/' + job.id">{{ job.title }}</a></td>
                        <td>{{ job.locationsText }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
    jobs: Array,
    locations: Array,
    careers: Array,
    detailBaseUrl: String,
    labels: Object,
});

const filters = ref({ location: '', career: '', search: '' });
const appliedFilters = ref({ location: '', career: '', search: '' });

const hasActiveFilters = computed(() =>
    appliedFilters.value.location || appliedFilters.value.career || appliedFilters.value.search
);

const displayedJobs = computed(() => {
    let result = props.jobs;

    if (appliedFilters.value.location) {
        const id = Number(appliedFilters.value.location);
        result = result.filter(job => job.locations.some(loc => loc.id === id));
    }
    if (appliedFilters.value.career) {
        const id = Number(appliedFilters.value.career);
        result = result.filter(job => job.careers.some(c => c.id === id));
    }
    if (appliedFilters.value.search) {
        const s = appliedFilters.value.search.toLowerCase();
        result = result.filter(job => job.title.toLowerCase().includes(s));
    }

    return result;
});

const entriesFoundText = computed(() =>
    (props.labels.entriesFound ?? '{count} Entries found').replace('{count}', displayedJobs.value.length)
);

function applyFilters() {
    appliedFilters.value = { ...filters.value };
    updateUrl();
}

function resetFilters() {
    filters.value = { location: '', career: '', search: '' };
    applyFilters();
}

function updateUrl() {
    const params = new URLSearchParams();

    if (filters.value.location) params.set('location', filters.value.location);
    if (filters.value.career)   params.set('career',   filters.value.career);
    if (filters.value.search)   params.set('search',   filters.value.search);

    const queryString = params.toString();
    const newUrl = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;

    window.history.pushState({}, '', newUrl);
}

function loadFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('location')) filters.value.location = Number(params.get('location'));
    if (params.has('career'))   filters.value.career   = Number(params.get('career'));
    if (params.has('search'))   filters.value.search   = params.get('search');
}

onMounted(() => {
    loadFiltersFromUrl();
    applyFilters();
});
</script>
